export default __webpack_public_path__ + "static/media/CV - Jost.65081c44.pdf";